document.querySelectorAll('ul.product-grid a').forEach(anchor => {
  const badge = document.createElement('span');
  badge.textContent = 'select options';

  // Base styling for the pill shape and font size
  badge.style.display = 'none';
  badge.style.marginLeft = '10px';
  badge.style.fontSize = '12px';
  badge.style.padding = '4px 10px';
  badge.style.borderRadius = '50px';

  // Visual defaults (adjust colors as needed)
  badge.style.backgroundColor = '#e0e0e0';
  badge.style.color = '#333333';
  badge.style.verticalAlign = 'middle';

  const heading = anchor.querySelector('p[role="heading"][aria-level="3"]');

  if (heading) {
    // Ensure the heading alignment accommodates the vertical pill placement
    heading.style.display = 'flex';
    heading.style.alignItems = 'center';

    heading.appendChild(badge);

    anchor.addEventListener('mouseenter', () => badge.style.display = 'inline-block');
    anchor.addEventListener('mouseleave', () => badge.style.display = 'none');
  }
});
